export const AppComponentService = {
  createListeners: [],
  DestroyRequestListeners: [],
  onContainerCreated(fn) {
    this.createListeners.push(fn);
  },
  onContainerDestroyed(fn) {
    this.DestroyRequestListeners.push(fn);
  },
  registerContainer(container) {
    this.createListeners.forEach(fn => {
      fn(container);
    });
  },
  destroyContainer(container) {
    this.DestroyRequestListeners.forEach(fn => {
      fn(container);
    });
  }
};
